<template>
  <div class="animated fadeIn">
    <div v-if="iscreate">
      <createfaq @created="iscreate = false"></createfaq>
    </div>
    <div v-if="isedit">
      <editfaq @edit="isedit = false" :itemObj="faq"></editfaq>
    </div>
    <div v-if="isview">
      <viewfaq @view="isview = false" :itemObj="faq"></viewfaq>
    </div>
    <b-card
      class="card-wrap"
      border-variant="info"
      v-if="!iscreate && !isedit && !isview"
    >
      <b-row>
        <b-col md="12" v-if="!iscreate && !isedit && !isview">
          <component-header
            title="FAQ Master Config"
            :isLoading="loading"
            @create-press="iscreate = true"
            :hasSearch="false"
            :hasClear="false"
            :hasReload="false"
          />
        </b-col>
      </b-row>

      <div class="mt-2" v-if="!iscreate && !isedit && !isview">
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :current-page="currentPage"
          :per-page="perPage"
          :items="faqs"
          thead-class="header"
          class="mt-3 tableRadius"
          :fields="Columns"
          show-empty
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <div class="inline_btnTable">
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="primary"
                @click="viewFaq(data)"
              >
                <i class="fa fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="primary"
                @click="editFaq(data)"
              >
                <i class="fas fa-pencil-alt edit"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="danger"
                @click="deleteFaq(data)"
              >
                <i class="fa fa-trash bin"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div style="float: right" v-if="!iscreate && !isedit && !isview">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="faqs.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
    </b-card>
  </div>
</template>
<script>
import ebButton from '@/components/FormElements/Button';
import loader from '@/components/loader/nipigeloader.vue';
import createfaq from '@/components/MasterSetup/FAQ/CreateFaq.vue';
import editfaq from '@/components/MasterSetup/FAQ/EditFaq.vue';
import viewfaq from '@/components/MasterSetup/FAQ/ViewFaq.vue';
import ComponentHeader from '@/components/componentHeader';

export default {
  name: 'faqdetails',
  components: {
    ebButton,
    loader,
    createfaq,
    editfaq,
    viewfaq,
    ComponentHeader,
  },
  data() {
    return {
      loading: false,
      perPage: 5,
      iscreate: false,
      isedit: false,
      isview: false,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: 'Add',
      faqModal: false,
      header: 'Edit Faq',
      sortBy: 'createdAt',
      sortDesc: true,
      faq: {},
      Columns: [
        {
          key: 'category',
          sortable: true,
        },
        {
          key: 'Topic',
        },
        {
          key: 'Description',
        },

        {
          key: 'action',
        },
      ],
    };
  },
  computed: {
    faqs() {
      let data = this.$store.getters['faq/GetFaqList'];
      let faqList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map(obj => {
          for (let i = 0; i < obj.items.length; i++) {
            let arrayObj = {
              _id: obj._id,
              category: obj.category,
              Topic: obj.items[i].topic,
              Description: obj.items[i].description,
              item_id: obj.items[i]._id,
              ...obj,
            };
            faqList.push(arrayObj);
          }
        });
        return faqList;
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    editFaq(data) {
      for (let i = 0; i < data.item.items.length; i++) {
        if (data.item.item_id === data.item.items[i]._id) {
          data.item.mediaType = data.item.items[i].media.mediaType;
          data.item.mediaContent = data.item.items[i].media.mediaContent;
        }
      }
      this.faq = data.item;
      this.isedit = true;
    },
    viewFaq(data) {
      for (let i = 0; i < data.item.items.length; i++) {
        if (data.item.item_id === data.item.items[i]._id) {
          data.item.mediaType = data.item.items[i].media.mediaType;
          data.item.mediaContent = data.item.items[i].media.mediaContent;
        }
      }
      this.faq = data.item;
      this.isview = true;
    },
    async deleteFaq(data) {
      this.$swal({
        title: 'Delete this FAQ?',
        text: "Are you sure? You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes, Delete it!',
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch('faq/deleteFaq', data.item._id + '/' + data.item.item_id)
            .then(result => {
              this.$toasted.success('Faq Deleted Successfully');
              this.$store
                .dispatch(
                  'faq/fetchFaqsList',
                  this.$store.getters['auth/getUserID']
                )
                .catch(error => {
                  this.$toasted.error(error.message);
                });
            });
        }
      });
      this.$store.dispatch(
        'faq/fetchFaqsList',
        this.$store.getters['auth/getUserID']
      );
    },

    clearModal() {
      this.faqModal = false;
      this.faq = {};
    },
  },
  async mounted() {
    await this.$store.dispatch('faq/fetchFaqsList').then(data => {
      if (data.message) {
        this.$toasted.error(data.message);
      } else {
      }
    });
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
